import React from 'react';

export const SearchResultRowSubcontent = (props: {
  children?: React.ReactNode;
}) => (
  <>
    <span className="SearchResultRowSubcontent">{props.children}</span>
    <style jsx>{`
      .SearchResultRowSubcontent {
        font-size: 12px;
      }
    `}</style>
  </>
);
